import React , { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom'
import { NavigationAOComponent } from './NavigationAO'
import axios from 'axios'
import { useToast } from "../../toastHook"
import { Modal } from 'bootstrap'
import { useAuthUser } from '../../auth'
import { displayConsultantExperience, displayConsultatLastActiviteSince } from '../../utils/experienceUtility'
import { getActivitesFromDetail, getExperienceFromDetail } from './GetAO';
import { InputTextarea } from 'primereact/inputtextarea';
import moment from 'moment';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

const getNiveauIcon = level => {
    if (level > 0) {
        return <>{level }<i className="pi pi-star-fill"></i></>
    }
    else {
        return <></>
    }
}

export const AOMatchedResultsComponent = ({ matchingResults, hasExplain, getDetail, onlyIntercontrats, getFeedback, setFeedback, aoId, aoParsed }) => {

    const { display } = useToast();
    const modalExplainRef = useRef();
    const modalSetFeedbackRef = useRef();
    const modalShowFeedbackRef = useRef();
    const [modalExplainHeader, setModalExplainHeader] = useState('');
    const [modalExplainBody, setModalExplainBody] = useState('');
    const [resultForSetFeedback, setResultForSetFeedback] = useState({});
    const [consultants, setConsultants] = useState([]);
    const [nbCountFeedbacks, setNbCountFeedbacks] = useState(0);
    const [feedbacks, setFeedbacks] = useState([]);

    const [rowFeedbacks, setRowFeedbacks] = useState([]);
    const [otherFeedbacks, setOtherFeedbacks] = useState([]);
    const [showFeedbacks, setShowFeedbacks] = useState([]);

    useEffect(() => {
        if (!getFeedback) {
            return;
        }

        getFeedback().then(response => {
            if (response.data) {
                setFeedbacks(response.data);
            }
        });
    }, [nbCountFeedbacks, aoId]);

    useEffect(() => {

        var tmpMap = new Map();

        feedbacks.forEach(x => {
            if (tmpMap.has(x.personalInfoId)) {
                tmpMap.set(x.personalInfoId, [...tmpMap.get(x.personalInfoId), x])
            }
            else {
                tmpMap.set(x.personalInfoId, [ x])
            }
        });

        var tmpRowFeedbacks = [];

        if (matchingResults) {

            tmpRowFeedbacks = matchingResults.map(x => {

                if (tmpMap.has(x.personalInfoId)) {
                    var values = tmpMap.get(x.personalInfoId);

                    tmpMap.delete(x.personalInfoId);

                    return values;
                }
                else {
                    return [];
                }

            })
        }

        var tmpOtherFeedbacks = [];

        tmpMap.forEach(v => tmpOtherFeedbacks.push(v));


        setRowFeedbacks(tmpRowFeedbacks);
        setOtherFeedbacks(tmpOtherFeedbacks);

    },[feedbacks, matchingResults ])

    let results = <div className="alert alert-primary" > aucun profil n'a été matché'  </div>

    const openCv = value => {

        const { personalInfoId, prenom, nom } = value;

        axios.get("/api/dcgenpageuser/getcv?personalinfoid=" + personalInfoId).then(response => {

            if (!response.data) {
                display({
                    titre: 'pas de cv',
                    text: `pas de cv pour ${prenom} ${nom}`,
                    severity: 'info'
                });
            }
            else {
                window.open(response.data, "_blank");
            }
        });
    }

    const openUserCompetence = value => {
        const { personalInfoId, prenom, nom } = value;

        axios.get("/api/dcgenpageuser/getcompetences?personalinfoid=" + personalInfoId).then(response => {

            if (!response.data) {
                display({
                    titre: 'pas de cv',
                    text: `pas de cv pour ${prenom} ${nom}`,
                    severity: 'info'
                });
            }
            else {
                window.open(response.data, "_blank");
            }
        });
    }

    const getMaxSkill = skills => {
        var skill = undefined;
        for (let i = 0; i < skills.length; ++i) {
            if (!skill) {
                skill = skills[i];
            }
            else if (skill.niveau < skills[i].niveau) {
                skill = skills[i]
            }
        }

        return skill;
    }

    const getMaxSkillNiveau = row => getMaxSkill(row.skills).niveau;

    const displayCompetenceBadge = (x, index, row) => {

        let skillToDisplay = getMaxSkill(x.skills);

        if (row.additionalInfo?.competencesPrincipales) {
            var thisCompetenceAdditionalInfo = row.additionalInfo.competencesPrincipales.find(y => y.competence === x.competence);

            if (thisCompetenceAdditionalInfo) {
                var title = thisCompetenceAdditionalInfo.lastSince ? `n'a pas pratiqué le ${x.competence} depuis ${thisCompetenceAdditionalInfo.lastSince.toFixed()} ans` : `n'a jamais pratiqué le ${x.competence}`;
                return <span key={index + '_' + x.competence} className={"bage badge-competence" + (thisCompetenceAdditionalInfo.malusType === "Max" ? "bg-danger" : "bg-warning")}  style={{ "white-space": "nowrap" }} data-toggle="tooltip" data-placement="bottom" title={title} >{x.competence} {getNiveauIcon(skillToDisplay.niveau)}</span>
            }
        }

        return <span key={index + '_' + x.competence} className="bage badge-competence bg-secondary" style={{ "white-space": "nowrap" } } data-toggle="tooltip" data-placement="bottom" title={ skillToDisplay.categorie + " - " + skillToDisplay.nom } >{x.competence} {getNiveauIcon(skillToDisplay.niveau)}</span>
    }

    const displayCompetenceLieeBadge = (x, index) => {
        return <span key={index + '_' + x.competence} className="bage badge-competence bg-primary" style={{ "white-space": "nowrap" }} data-toggle="tooltip" data-placement="bottom" title={ x.competence +  " liée à " + x.competenceLiee } >{x.competence}>{x.competenceLiee} {getNiveauIcon(x.niveau)}</span>
    }

    const openExplainModal = index => {

        let userResult = matchingResults[index - 1];

        setModalExplainHeader(`Explication du matching pour ${userResult.prenom}  ${userResult.nom}`);
        setModalExplainBody("téléchargement en cours");

        getDetail(index)
            .then(response => {
                if (response.data) {
                    setModalExplainBody(response.data);
                }
                else {
                    setModalExplainBody("impossible de télécharger l'explication");
                }
            })

        const modal = Modal.getOrCreateInstance(modalExplainRef.current);
        modal.show();
    }

    const displayConsultantActiviteExperience = activites => {
        if (!activites || activites.length === 0) {
            return "";
        }
        else if (activites.length === 1) {
            return displayConsultantExperience(activites[0].experience);
        }
        else {
            let experiences = activites.filter(x => x.experience >= 0 ).map(x => x.experience);

            if (experiences.length === 0) {
                return "inconnu";
            }

            let minExperience = Math.min(...experiences);
            let maxExperience = Math.max(...experiences);

            return "[" + displayConsultantExperience(minExperience) + " - " + displayConsultantExperience(maxExperience) + "]";
        }
    }

    const displayConsultantActiviteLastSince = activites => {
        if (!activites || activites.length === 0) {
            return "";
        }
        else if (activites.length === 1) {
            return displayConsultatLastActiviteSince(activites[0].lastSince);
        }
        else {
            let lastSinces = activites.map(x => x.lastSince);

            let maxLastSince = Math.max(...lastSinces);

            return displayConsultatLastActiviteSince(maxLastSince);
        }
    }

    const displayDateDisponibilite = row => {
        if (!row.dateDisponibilite) {
            return "inconnue";
        }
        else {
            return moment(row.dateDisponibilite).format('ll');
        }
    }

    const onSetFeedback = row => {

        setConsultants([]);

        setResultForSetFeedback({
            feedbackScore: undefined,
            feedbackMessage: "",
            personalInfoId: row.personalInfoId,
            nom: row.nom,
            prenom: row.prenom,
            search: '',
            canSelect : !row.personalInfoId
        });

        const modal = Modal.getOrCreateInstance(modalSetFeedbackRef.current);
        modal.show();
    }

    const onCloseFeedbackModal = () => {
        const modal = Modal.getOrCreateInstance(modalSetFeedbackRef.current);
        modal.hide();
    }

    const sendFeedback = () => {

        if ( resultForSetFeedback.feedbackScore === undefined || !resultForSetFeedback.personalInfoId ) {
            return;
        }

        setFeedback(resultForSetFeedback, () => setNbCountFeedbacks(nbCountFeedbacks + 1));

        onCloseFeedbackModal();
    }

    const searchConsultant = () => {

        if (!resultForSetFeedback.search || resultForSetFeedback.search.length <= 3) {
            return;
        }

        axios.get("/api/feedback/searchuser?search=" + encodeURI(resultForSetFeedback.search))
            .then(response => {
                if (response.data) {
                    setConsultants(response.data)
                }
            })
    }

    const changeConsultant = row => {
        setResultForSetFeedback({ ...resultForSetFeedback, prenom: row.data.firstName, nom: row.data.lastName, personalInfoId: row.data.id });
        setConsultants([]);

    }

    const getFeedbackIcon = feedbacks => {


        if (feedbacks.length === 0) {
            return <i className="pi pi-minus text-primary" />
        }

        var min = Math.min(...feedbacks.map(x => x.feedbackScore));
        var max = Math.max(...feedbacks.map(x => x.feedbackScore));

        if (min === -1) {
            return <i className="pi pi-thumbs-down-fill text-danger" onClick={ () => onShowFeedbackModal(feedbacks) } />
        }

        if (max === 1) {
            return <i className="pi pi-thumbs-up-fill text-success" onClick={() => onShowFeedbackModal(feedbacks)} />
        }

        return <i className="pi pi-minus text-secondary" onClick={() => onShowFeedbackModal(feedbacks)} />
    }


    const getFeedbackIconFromScore = score => {
        if (score === -1) {
            return <i className="pi pi-thumbs-down-fill text-danger"/>
        }

        if (score === 1) {
            return <i className="pi pi-thumbs-up-fill text-success"  />
        }

        return <i className="pi pi-minus text-secondary"  />

    }

    const getFeedbackIconFromIndex = index => {

        if (rowFeedbacks.length <= index) {
            return <i className="pi pi-minus text-primary" />
        }

        return getFeedbackIcon(rowFeedbacks[index]);

    }

    const onShowFeedbackModal = feedbacks => {
        setShowFeedbacks(feedbacks);

        const modal = Modal.getOrCreateInstance(modalShowFeedbackRef.current);
        modal.show();
    }

    const onCloseShowFeedbackModal = () => {
        const modal = Modal.getOrCreateInstance(modalShowFeedbackRef.current);
        modal.hide();
    }

    const displayAdditionalInfos = row => {
        if (!row.additionalInfo?.competencesLiees ) {
            return <></>
        }

        return row.additionalInfo.competencesLiees.map(x => displayCompetenceLieeBadge(x));
    }

    var otherFeedbacksHtml = <></>;
    if (setFeedback) {
        otherFeedbacksHtml = <div className="alert alert-info"><div className="d-flex flex-row gap-3 justify-content-between"><span>Ajouter un nouveau feedback </span><button className="btn btn-outline-primary" onClick={() => onSetFeedback({})} >Nouveau feedback</button> </div></div>
    }
    if (otherFeedbacks.length > 0) {
        otherFeedbacksHtml  = <div className="card" >
            <div className="card-body">
                <div className="card-title"><div className="d-flex flex-row gap-3 justify-content-between">
                    <span><b>Feedback de consultants non présents</b></span>
                    {setFeedback ? <button className="btn btn-outline-primary" onClick={() => onSetFeedback({})} >Nouveau feedback</button> : <></>}
                </div>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                    <th>Feedback</th>
                    <th>Nom</th>
                            <th>Prénom</th>
                            { setFeedback ? <th></th> : <></>}
                        </tr>
                        </thead>
                    <tbody>
                        {otherFeedbacks.map((x,i) => {
                            return <tr key={x[0].prenom + x[0].nom  + i }>
                                <td>{getFeedbackIcon(x)}</td>
                                <td> {x[0].prenom}</td>
                                <td>{x[0].nom}</td>
                                {setFeedback ? <td><i className="pi pi-question-circle text-primary" onClick={() => onSetFeedback({ nom: x[0].nom, prenom: x[0].prenom, personalInfoId: x[0].personalInfoId })} /></td> : <></>}
                                    </tr>
                        }) }
                    </tbody>
                </table>
            </div>
        </div>
    }


    if (matchingResults.length > 0 && aoParsed?.value?.competences) {
        results = <div>
            <table className="table">
                <thead>
                    <tr>
                        {getFeedback ? <th>Feedback</th> : <></>}
                        <th>Score</th>
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>BU</th>
                        {onlyIntercontrats ? <th>Date disponibilité</th> : <></>}
                        <th>Compétences trouvées</th>
                        <th>Compétences communes</th>
                        <th>Expérience (années)</th>
                        <th>Dernière depuis (années)</th>
                        <th>Expérience totale (années)</th>
                        <th>Détail</th>
                    </tr>
                </thead>
                <tbody>
                    {matchingResults.map((x, index) => {

                        var explain = <></>
                        if (hasExplain) {
                            explain = <i onClick={() => openExplainModal(index + 1)} className="pi pi-id-card text-primary" />
                        }

                        var setFeedbackIcon = <></>
                        if (setFeedback) {
                            setFeedbackIcon = <i className="pi pi-question-circle text-primary" onClick={() => onSetFeedback(x)} />
                        }

                        return <tr key={index}>
                            {getFeedback ? <td>{getFeedbackIconFromIndex(index)}</td> : <></>}
                            <td>{x.score ? x.score.toFixed() : ''}</td>
                            <td>{x.nom}</td>
                            <td>{x.prenom}</td>
                            <td>{ x.bu }</td>
                            {onlyIntercontrats ? <td>{displayDateDisponibilite(x)}</td> : <></>}
                            <td>{x.competences.filter(x => getMaxSkillNiveau(x) >= 1).length} / {aoParsed.value.competences.length} </td>
                            <td><div className="d-flex flex-wrap gap-2">{x.competences.filter(y => getMaxSkillNiveau(y) >= 1).map(y => displayCompetenceBadge(y, index, x))}{displayAdditionalInfos(x)}</div> </td>
                            <td>{displayConsultantActiviteExperience(x.activites)}</td>
                            <td>{displayConsultantActiviteLastSince(x.activites)}</td>
                            <td>{displayConsultantExperience(x.totalExperience)}</td>
                            <td>
                                <div className="d-flex flex-row gap-2">
                                    <i onClick={() => openCv({ personalInfoId: x.personalInfoId, prenom: x.prenom, nom: x.nom })} className="pi pi-info-circle text-primary" />
                                    <i onClick={() => openUserCompetence({ personalInfoId: x.personalInfoId, prenom: x.prenom, nom: x.nom })} className="pi pi-list text-primary" />
                                    {explain}
                                    {setFeedbackIcon}
                                </div>
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

        return <>
            {otherFeedbacksHtml }
            {results}
            <div ref={modalExplainRef} className="modal fade" id="fullscreenModal" tabIndex="-1" aria-labelledby="explainModal" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="explainModal">{modalExplainHeader}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                        </div>
                        <div className="modal-body">
                                <div>
                                    {modalExplainBody.split('\n').map((rowText, index) => (
                                        <div key={index}>
                                            {rowText}
                                        </div>
                                    ))}
                                </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={ modalSetFeedbackRef } className="modal fade" id="modalSetFeedback" tabIndex="-1" role="dialog" aria-labelledby="modalSetFeedbackTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalSetFeedbackLongTitle">
                                { resultForSetFeedback.prenom && resultForSetFeedback.nom ?  
                                    <>Feedback pour {resultForSetFeedback.prenom} {resultForSetFeedback.nom}</>
                                    : <>Ajouter un feedback</>
                                }</h5>
                            <button type="button" className="close" data-dismiss="modal"  aria-label="Close" onClick={ onCloseFeedbackModal }>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column gap-3">
                                { resultForSetFeedback.canSelect ? 
                                    <div className="card" >
                                        <div className="card-body">
                                            <h5 className="card-title">Changer de consultant</h5>
                                            <div className="d-flex flex-row gap-3"><input type="email" className="form-control flex-grow-1" placeholder="Recherche un consultant" value={resultForSetFeedback.search} onChange={e => setResultForSetFeedback({ ...resultForSetFeedback, search: e.target.value })}></input>
                                                <button className="btn btn-success" style={{ "minWidth": "180px" }} onClick={searchConsultant}>Recherche consultant</button></div>
                                            {consultants ?
                                                <DataTable value={consultants} tableStyle={{ width: '100%' }} onRowClick={changeConsultant} paginator rows={5}>
                                                    <Column field="firstName" header="Prénom" />
                                                    <Column field="lastName" header="Nom" />
                                                </DataTable>
                                                : <></>}
                                        </div>
                                    </div>
                               : <></> }
                                <div className="d-flex flex-row justify-content-center gap-5" >
                                <i className={"pi pi-thumbs-down-fill " + (resultForSetFeedback.feedbackScore === -1 ? "text-danger" : "text-primary")} onClick={() =>  setResultForSetFeedback({ ...resultForSetFeedback,  feedbackScore : -1 })  } />
                                <i className={"pi pi-minus " + (resultForSetFeedback.feedbackScore === 0 ? "text-secondary" : "text-primary")} onClick={() =>  setResultForSetFeedback({ ...resultForSetFeedback, feedbackScore: 0 }) } />
                                <i className={"pi pi-thumbs-up-fill " + (resultForSetFeedback.feedbackScore === 1 ? "text-success" : "text-primary")} onClick={() => setResultForSetFeedback({ ...resultForSetFeedback, feedbackScore: 1 })} />
                                </div>
                                <div className="text-center">
                                    <InputTextarea value={resultForSetFeedback.feedbackMessage} onChange={e => setResultForSetFeedback({ ...resultForSetFeedback, feedbackMessage: e.target.value })} rows={2} cols={50} autoResize={ true } />
                                </div>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={onCloseFeedbackModal}>Fermer</button>
                            <button type="button" className="btn btn-success" onClick={ () => sendFeedback() } >Envoie feedback</button>
                        </div>
                    </div>
                </div>
                </div>
            <div ref={modalShowFeedbackRef} className="modal fade"  id="modalShowFeedback" tabIndex="-1" role="dialog" aria-labelledby="modalShowFeedbackTitle" aria-hidden="true" >
                <div className="modal-dialog modal-xl" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="modalShowFeedbackLongTitle">
                                    {showFeedbacks.length > 0 ?
                                        <>Feedback pour {showFeedbacks[0].prenom} {showFeedbacks[0].nom}</> : <>titi</>
                                    }</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCloseShowFeedbackModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <table className="table" style={{ width:"100%" } }>
                                <thead>
                                    <tr>
                                        <th>Feedback Origine</th>
                                        <th>Feedback</th>
                                        <th>Prénom</th>
                                        <th>Nom</th>
                                        <th>Commentaire</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {showFeedbacks.map((x, i) => {
                                        return <tr key={i}>
                                            <td>{x.sourceFeedbackPrenom} {x.sourceFeedbackNom}</td>
                                            <td>{ getFeedbackIconFromScore(x.feedbackScore) }</td>
                                            <td>{x.prenom}</td>
                                            <td>{x.nom}</td>
                                            <td>{ x.feedbackMessage }</td>
                                        </tr>
                                    }) }
                                </tbody>
                            </table>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-dismiss="modal" onClick={onCloseShowFeedbackModal}>Fermer</button>
                            </div>
                        </div>
                    </div>
                    </div>
        </>
    }

export const ResultMatchAOComponent = ({ canExplain, matchingResults, aoParsed, getDetail, onlyIntercontrats, setFeedback, getFeedback , aoId }) => {

    let detailComponent = <></>

    if ( aoParsed && aoParsed.value && aoParsed.value.activites && aoParsed.value.activites.length > 0) {
        detailComponent = <div>
            <div className="card mt-3 mb-3">
                <div className="card-header">
                    Activité
                </div>
                <div className="card-body">

                    Activité: {getActivitesFromDetail(aoParsed)} <br />
                    Expérience: {getExperienceFromDetail(aoParsed)} <br />

                </div>
            </div>
            <div className="card mb-3">
                <div className="card-header">
                    Compétences  obligatoires
                </div>
                <div className="card-body">
                    <div className="d-flex flex-wrap gap-2">{aoParsed.value.competences.filter(x => aoParsed.value.competencesBloquantes.find(y => y === x.nom))
                        .map(x => <span key={'hh' + x.nom} className="bage bg-secondary" style={ { "white-space" : "nowrap" } }>{x.nom} {getNiveauIcon(x.niveau)}</span>)}</div>
                </div>
            </div>
            <div className="card mb-3">
                <div className="card-header">
                    Compétences
                </div>
                <div className="card-body">
                    <div className="d-flex flex-wrap gap-2">{aoParsed.value.competences.filter(x =>  !aoParsed.value.competencesBloquantes.find(y => y === x.nom))
                        .map(x => <span key={'aa' + x.nom} className="bage bg-secondary" style={{ "white-space": "nowrap" }}>{x.nom} {getNiveauIcon(x.niveau)}</span>)}</div>
                </div>
            </div>
        </div>
    }



    return <>
        {detailComponent}
        <AOMatchedResultsComponent matchingResults={matchingResults} hasExplain={canExplain} getDetail={getDetail} onlyIntercontrats={onlyIntercontrats} setFeedback={setFeedback} getFeedback={getFeedback} aoId={aoId} aoParsed={aoParsed } />
    </>
}

export const AOMatchedComponent = () => {

    const { checkRole } = useAuthUser();
    const { aoId } = useParams();
    const [detail, setDetail] = useState();
    const [matchingResults, setMatchingResults] = useState([]);
    const [canExplain, setCanExplain] = useState(false);
    const { display } = useToast();

    useEffect(() => {
        axios.get('/api/aoget/matched?id=' + aoId)
            .then(response => {
                if (response.data) {
                    setMatchingResults(response.data)
                }
            });
    }, [aoId]);

    useEffect(() => {
        axios.get('/api/aomatched/hasexplain?aoid=' + aoId)
            .then(response => {
                if (response.data && checkRole('Pocahontas_Explain')) {
                    setCanExplain(true)
                }
            });
    }, [aoId]);

    const setFeedback = (feedback, onSuccess) => {
        axios.post("/api/feedback/set?aoId=" + aoId, { feedbackScore : feedback.feedbackScore, feedbackMessage:  feedback.feedbackMessage, personalInfoId : feedback.personalInfoId })
            .then(response => {
                if (response.status === 200) {
                    display({
                        titre: 'feedback enregistré',
                        text: `feedback enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'success'
                    });

                    onSuccess();
                }
                else {
                    display({
                        titre: 'feedback non entregistré',
                        text: `feedback non enregistré pour  ${feedback.prenom} ${feedback.nom}`,
                        severity: 'danger'
                    });
                }
            });
    }

    const getFeedback = () => axios.get("/api/feedback/get?aoId=" + aoId);


    const getDetail = index => {
        return axios.get('/api/aomatched/explain?aoid=' + aoId + '&rownumber=' + index)
    }

    return <div > <NavigationAOComponent aoId={aoId} pageType={"matched"} setDetailWhenReceived={x => setDetail(x)} />
        {(detail ? <ResultMatchAOComponent canExplain={canExplain} matchingResults={matchingResults} aoParsed={detail.resultat} getDetail={getDetail} onlyIntercontrats={detail.onlyIntercontrat} setFeedback={setFeedback} getFeedback={getFeedback} aoId={ aoId } /> : <></>)}
    </div>
}








